import client from '@/client/apiClient';
import UserMegaLeague from '@/models/MegaLeague/userMegaLeague';
import PaginatedUserMegaLeagueCollection from '@/models/MegaLeague/paginatedUserMegaLeagueCollection';

export default class MegaLeagueService {
  static getUserMegaLeague(gameWeekNumber) {
    return client
      .get(`/game-week/${gameWeekNumber}/mega-league`)
      .then((response) => UserMegaLeague.createFromObject(response.data));
  }

  static putUserMegaLeague(gameWeekNumber, lineup) {
    return client
      .put(`/game-week/${gameWeekNumber}/mega-league`, lineup);
  }

  static deleteUserMegaLeague(gameWeekNumber) {
    return client
      .delete(`/game-week/${gameWeekNumber}/mega-league`);
  }

  static getLeaderboard(gameWeekNumber, page) {
    return client
      .get(`/game-week/${gameWeekNumber}/mega-league/leaderboard?page=${page}`)
      .then((response) => PaginatedUserMegaLeagueCollection.createFromObject(response.data));
  }

  static getUserMegaLeagueByUser(gameWeekNumber, userSlug) {
    return client
      .get(`/game-week/${gameWeekNumber}/manager/${userSlug}/mega-league`)
      .then((response) => UserMegaLeague.createFromObject(response.data));
  }

}
